import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { RadioButton } from '@hub/models/radioButton.model';

const noop = () => {};

export const CUSTOM_FMRADIO_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FormRadioComponent),
  multi: true
};

@Component({
  selector: 'fm-radioGroup',
  templateUrl: 'form-radio.component.html',
  providers: [CUSTOM_FMRADIO_CONTROL_VALUE_ACCESSOR]
})

export class FormRadioComponent
  implements  ControlValueAccessor, OnInit, OnDestroy {
  constructor() {}

  @Input() disabled: boolean = false;
  @Input() radioButtonData: RadioButton[];
  @Output() onClick: EventEmitter<any> = new EventEmitter();

  tabindex: string;
  @Input('tabindex')
  set tabin(val: string) {
    this.tabindex = String(val);
  }

  public Arr = Array;
  private innerValue: boolean;
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  ngOnInit() {
  }

  ngOnDestroy() {
  }

  get value(): any {
    return this.innerValue;
  }

  // set accessor including call the onchange callback
  set value(v: any) {
    if (v !== this.value) {
      this.writeValue(v);
      this.onChangeCallback(v);
    }
  }

  onChange(obj: { originalEvent: Event; value: boolean }) {
    if (obj.value !== this.innerValue) {
      this.writeValue(obj.value);
      this.onChangeCallback(obj.value);
      this.onClickCallback(event);
    }
  }

  onClickCallback(event: object) {
    this.onClick.emit(event);
  }

  //From ControlValueAccessor interface
  writeValue(value: any) {
    if (value !== this.innerValue) {
      this.innerValue = value;
    }
  }

  //From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }
}
